// extracted by mini-css-extract-plugin
export var container = "_ce-0";
export var popoverContent = "_ce-1";
export var tosLink = "_ce-2";